import z from "zod";
export const OfficerRequestStatusValues = [
    "decisionNeeded",
    "notRequested",
    "requested",
    "accepted",
    "rejected",
];
export const OfficerRequestStatusSchema = z.enum(OfficerRequestStatusValues);
//# sourceMappingURL=shareableIncidentData.js.map